import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import SetMealEditor from './SetMealEditor'
import Item from '../Item'
import styles from './style.module.less'
import { getText } from '../../utils'
import { isWeddingRingJewelryProperty } from '@merchant-backend/util'

@inject('stepTwoStore')
@observer
export default class extends Component {
  render() {
    return (
      <Item label="详情描述" required>
        <div className={styles.tip}>
          请完善「图文介绍、服务内容{!isWeddingRingJewelryProperty() &&
            '、相关案例'}」。错误填写{getText()}内容，可能会引起{getText()}下架或流量减少，影响您的正常销售，请认真准确填写。
        </div>
        <SetMealEditor store={this.props.stepTwoStore} />
      </Item>
    )
  }
}
